import { ReportAllocatedAndSubsidies40Container } from "../../../containers/SupportSystem/Reports/ReportAllocatedAndSubsidies40Container";
export function ReportAllocatedAndSubsidies40Page() {
    return (
        <ReportAllocatedAndSubsidies40Container />
    );

}